var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpCircle = function SvgHelpCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "help-circle_svg__a",
    width: 18,
    height: 18,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#737E8C",
    strokeWidth: 1.929,
    mask: "url(#help-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.072A7.071 7.071 0 1 0 9 1.929a7.071 7.071 0 0 0 0 14.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M8.986 13.166h.026v.026h-.026z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M7.07 6.75a1.929 1.929 0 1 1 3.122 1.516c-.558.438-1.193.989-1.193 1.698"
  }))));
};
export default SvgHelpCircle;